const darkColors = {
  // Primary Brand Color
  primary: "#6F3AFF", // Electric Indigo
  secondary: "#00F0FF",

  // Backgrounds
  background: "#0D0D0D", // Deep Navy
  surface: "blue", // Elevated surfaces like cards or modals

  // Navigation
  navigation: {
    background: "#1C1C1C",
    text: "#FFFFFF",
    active: "#FFFFFF",
    inactive: "#666666",
  },

  // Text
  text: {
    primary: "#FFFFFF",
    secondary: "#B1B3C6",
    disabled: "#666666",
    placeholder: "#888888",
  },

  // Borders
  border: {
    default: "#1F2233",
    focus: "#6F3AFF",
  },

  // Buttons
  button: {
    primary: {
      background: "#6F3AFF",
      text: "#FFFFFF",
      disabledBackground: "#2D2D2D",
      disabledText: "#888888",
    },
    secondary: {
      background: "#1E1E1E",
      text: "#E0E0E0",
      disabledBackground: "#2D2D2D",
      disabledText: "#888888",
    },
  },

  // Input Fields
  input: {
    background: "#1A1A1A",
    text: "#FFFFFF",
    placeholder: "#888888",
    border: "#333333",
    focusBorder: "#6F3AFF",
  },

  // Status Colors
  status: {
    success: "#00C896",
    warning: "#F5A623",
    danger: "#FF4F4F",
    error: "#FF3B30",
    info: "#00F0FF", // Cyber Aqua as info accent
  },
};

const uroTheme = {
  colors: darkColors,
};

export default uroTheme;
